<template>
  <div id="app">
    <notifications position="bottom right" group="notify" />
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
const defaultLayout = 'default'
export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  }
}
</script>

<style>
@import './assets/style.css';
@import url('https://pro.fontawesome.com/releases/v5.10.0/css/all.css');
@import url('https://fonts.cdnfonts.com/css/inter');
/* ── Light (default) ── */
:root,
html.theme-light {
  --bg-base:   #f4f4f6;
  --bg-panel:  #ffffff;
  --bg-hover:  #f0f0f4;
  --border:    #e5e5e8;
  --border-2:  #d0d0d4;
  --text-1:    #111111;
  --text-2:    #555555;
  --text-3:    #999999;
  --accent:    #f42f4b;
}

/* ── Dark ── */
html.theme-dark {
  --bg-base:   #0a0a0f;
  --bg-panel:  #111115;
  --bg-hover:  #1a1a1e;
  --border:    #1e1e1e;
  --border-2:  #2a2a2a;
  --text-1:    #ffffff;
  --text-2:    #aaaaaa;
  --text-3:    #555555;
  --accent:    #f42f4b;
}

/* Transition روی همه چیز */
*, *::before, *::after {
  transition: background-color .2s, border-color .2s, color .2s;
}
</style>
